import RelationshipType from "./models/RelationshipType.mjs";
import Gender from "./models/Gender.mjs";
import Self from "./models/Self.mjs";
import utils from "./utils.mjs";
const roundToTwoDecimals = utils.roundToTwoDecimals;
const roundToSixDecimals = utils.roundToSixDecimals;
const filterFullSiblings = utils.filterFullSiblings;
const filterMaternalHalfSiblings = utils.filterMaternalHalfSiblings;
const filterPaternalHalfSiblings = utils.filterPaternalHalfSiblings;
import { fraction, multiply, subtract, number } from "mathjs";
let taseeb = 0;
let calculationQueue;
let currentCalcuation = null;
let self;
export function calculateInheritance(amount) {
    self = Self.get();
    self._livingGrandSons = _getLivingInheritorsWithinList(_getGrandSons());
    self._livingGrandDaughters = _getLivingInheritorsWithinList(_getGrandDaughters());
    self.hasLivingMaleDescendent =
        _getLivingInheritorsWithinList(self._sons).length > 0 ||
            self._livingGrandSons.length > 0;
    self.hasLivingFemaleDescendent =
        _getLivingInheritorsWithinList(self._daughters).length > 0 ||
            _isGrandDaughterEligible();
    if (self.relationshipType != RelationshipType.SELF) {
        console.log("First member must be of Relationship Type SELF");
    }
    if (self.alive) {
        console.log("First member must be listed as deceased");
    }
    taseeb = amount;
    _calculate(amount);
    _roundAllInheritorAmountsToTwoDecimals();
}
function _roundAllInheritorAmountsToTwoDecimals() {
    self._allInheritors.forEach((inheritor) => (inheritor.amountDue = roundToTwoDecimals(inheritor.amountDue)));
}
function _calculateForPaternalAscendant(ascendant, total) {
    if (self.hasLivingMaleDescendent) {
        ascendant.amountDue = total / 6;
    }
    else if (calculationQueue.length > 0) {
        // If deceased has 0 living male descendants, then ascendant should be the last to have inheritance calculated
        _addCalculationBackToQueue();
        return;
    }
    else {
        if (self.hasLivingFemaleDescendent) {
            ascendant.amountDue = total / 6;
        }
        // Ascendant always gets Taseeb unless deceased has living male descendant
        ascendant.amountDue = taseeb;
    }
    taseeb -= ascendant.amountDue;
}
function _calculateForFather(total) {
    const father = self._father;
    if (!(father === null || father === void 0 ? void 0 : father.alive)) {
        return;
    }
    _calculateForPaternalAscendant(father, total);
}
function _calculateForMother(total) {
    const mother = self._mother;
    if (!(mother === null || mother === void 0 ? void 0 : mother.alive)) {
        return;
    }
    const percentageDue = self.hasLivingMaleDescendent ||
        self.hasLivingFemaleDescendent ||
        _getLivingInheritorsFromList([...self._brothers, ...self._sisters]).length >
            1
        ? 1 / 6
        : 1 / 3;
    mother.amountDue = total * percentageDue;
    taseeb -= mother.amountDue;
}
function _setAmountForAllItemsInList(list, ratio, totalToSplit) {
    let amountDistributed = 0;
    const amount = ratio * totalToSplit;
    for (const member of list) {
        if (!member.alive) {
            continue;
        }
        member.amountDue = amount;
        amountDistributed += amount;
    }
    return amountDistributed;
}
function _calculateTaseebPortionsForBothGendersAtSameLevel(maleInheritors, femaleInheritors) {
    let amountDistributed = 0;
    const portions = 2 * maleInheritors.length + femaleInheritors.length;
    const ratioDueForMales = 2 / portions;
    amountDistributed += _setAmountForAllItemsInList(maleInheritors, ratioDueForMales, taseeb);
    const ratioDueForFemales = 1 / portions;
    amountDistributed += _setAmountForAllItemsInList(femaleInheritors, ratioDueForFemales, taseeb);
    return amountDistributed;
}
function _calculateForChildren(amount) {
    let amountDistributed = 0;
    if (self.hasLivingSon && self.hasLivingDaughter) {
        amountDistributed = _calculateTaseebPortionsForBothGendersAtSameLevel(self._sons, self._daughters);
    }
    else if (self.hasLivingSon) {
        const ratioDue = 1 / self._sons.length;
        amountDistributed += _setAmountForAllItemsInList(self._sons, ratioDue, taseeb);
    }
    else if (self.hasLivingDaughter) {
        const fractionOwedToDaughters = self._daughters.length == 1 ? 1 / 2 : 2 / 3;
        const ratioDue = fractionOwedToDaughters / self._daughters.length;
        amountDistributed += _setAmountForAllItemsInList(self._daughters, ratioDue, amount);
    }
    amountDistributed = roundToSixDecimals(amountDistributed);
    taseeb -= amountDistributed;
    taseeb = roundToSixDecimals(taseeb);
}
function _calculateForWives(amount) {
    if (self._spouses.length == 0 || self.gender == Gender.FEMALE) {
        return;
    }
    const fractionOwedToWives = self._sons.length > 0 || self._daughters.length > 0 ? 1 / 8 : 1 / 4;
    const ratioDue = fractionOwedToWives / self._spouses.length;
    taseeb -= _setAmountForAllItemsInList(self._spouses, ratioDue, amount);
}
function _calculateForHusband(amount) {
    if (self._spouses.length == 0 || self.gender == Gender.MALE) {
        return;
    }
    const fractionOwedToHusband = self._sons.length > 0 || self._daughters.length > 0 ? 1 / 4 : 1 / 2;
    const amountToGive = fractionOwedToHusband * amount;
    // Females can only have a single husband, so just need to get the first one
    self._spouses[0].amountDue = amountToGive;
    taseeb -= amountToGive;
}
function _addCalculationBackToQueue() {
    if (currentCalcuation == null) {
        throw new Error("Cannot add calculation back to queue - value is null");
    }
    calculationQueue.push(currentCalcuation);
    currentCalcuation = null;
}
function _getCommonDenominator(total) {
    if (total == 0) {
        return 1;
    }
    let commonDenominator = 1;
    self._allInheritors.forEach((inheritor) => {
        commonDenominator *= fraction(inheritor.amountDue / total).d;
    });
    return commonDenominator;
}
function _getTotalDistributedPortions(inheritors, commonDenominator, total) {
    let totalDistributedPortionsWithoutSpouse = 0;
    inheritors.forEach((inheritor) => {
        const ratio = fraction(inheritor.amountDue / total);
        const increaseFactor = commonDenominator / ratio.d;
        totalDistributedPortionsWithoutSpouse += ratio.n * increaseFactor;
    });
    return totalDistributedPortionsWithoutSpouse;
}
function _setNewRatiosForCalculationCorrection(inheritors, newRatioMap, commonDenominator, total, totalDistributedPortions) {
    for (const inheritor of inheritors) {
        if (inheritor.amountDue == 0)
            continue;
        const ratio = fraction(inheritor.amountDue / total);
        const increaseFactor = commonDenominator / ratio.d;
        const newRatio = fraction(ratio.n * increaseFactor, totalDistributedPortions);
        newRatioMap.set(inheritor, newRatio);
    }
}
function _subtractSpousePortionsForRaddResults(newRatioMap, total, totalSpouseDistribution) {
    for (const inheritor of self._allInheritorsExcludingSpouses) {
        const inheritorNewRatio = newRatioMap.get(inheritor);
        if (!inheritorNewRatio)
            continue;
        const quotient = roundToSixDecimals(number(inheritorNewRatio));
        const amountToRemove = multiply(inheritorNewRatio, totalSpouseDistribution);
        const finalResult = subtract(quotient, amountToRemove);
        inheritor.amountDue = number(multiply(finalResult, total));
    }
}
function _getLivingInheritorsFromList(inheritors) {
    return inheritors.filter((inheritor) => inheritor.alive);
}
function _calculateRadd(total) {
    // _printLivingInheritors()
    const newRatioMap = new Map();
    // Get copy of self without spouse for easier calculations
    const nonSpousalInheritors = self._allInheritorsExcludingSpouses;
    const commonDenominatorWithoutSpouse = _getCommonDenominator(total);
    // 1. Sum up fixed distributions for non-spousal inheritors
    const totalDistributedPortionsWithoutSpouse = _getTotalDistributedPortions(nonSpousalInheritors, commonDenominatorWithoutSpouse, total);
    // 2. Use numerator after summation as new denominator for non-spousal inheritors, if any exist
    _setNewRatiosForCalculationCorrection(self._allInheritorsExcludingSpouses, newRatioMap, commonDenominatorWithoutSpouse, total, totalDistributedPortionsWithoutSpouse);
    // 3. Get total distribution for spouses
    const totalSpouseDistribution = self._spouses.length > 0
        ? fraction((self._spouses[0].amountDue * self._spouses.length) / total)
        : fraction(0);
    // 4. Subtract proportional amount for spouse from all other inheritor distributions
    _subtractSpousePortionsForRaddResults(newRatioMap, total, totalSpouseDistribution);
}
function applyAwalValues(newRatioMap, total) {
    newRatioMap.forEach((ratio, familyMember) => {
        familyMember.amountDue = number(multiply(ratio, total));
    });
}
function _calculateAwal(total) {
    const newRatioMap = new Map();
    const commonDenominator = _getCommonDenominator(total);
    // 1. Sum up fixed distributions for all inheritors
    const totalDistributedPortions = _getTotalDistributedPortions(self._allInheritors, commonDenominator, total);
    // 2. Use numerator after summation as new denominator for all inheritors
    _setNewRatiosForCalculationCorrection(self._allInheritors, newRatioMap, commonDenominator, total, totalDistributedPortions);
    applyAwalValues(newRatioMap, total);
}
/**
 * It is possible after all of the typical calculations, the total distribution is too high or too little, meaning
 * if the total inheritance is $1000, the total distributed to the inheritors add up to more than or less than $1000.
 * This method proportionally correct the distributions so that the total adds up to the initial inheritance.
 * @param self deceased family member
 * @returns
 */
function _fixPortionsIfTaseebIsNotZero(total) {
    // Nothing to fix
    if (taseeb == 0) {
        return;
    }
    else if (_getLivingInheritorsFromList(self._allInheritorsExcludingSpouses).length ==
        0) {
        // If only spousal inheritors are alive, split inheritance between spouse
        _setAmountForAllItemsInList(self._spouses, 1 / self._spouses.length, total);
        return;
    }
    else if (taseeb > 0) {
        _calculateRadd(total);
    }
    else {
        _calculateAwal(total);
    }
}
function _fixPortionsForUmariCases(total) {
    // Reset Taseeb
    taseeb = total;
    _calculateForHusband(total);
    _calculateForWives(total);
    const amountPerPortion = taseeb / 3;
    self._father.amountDue = 2 * amountPerPortion;
    self._mother.amountDue = amountPerPortion;
    taseeb = 0;
}
/**
 * Check if both parents and spouses are the only inheritors
 */
function _isUmariCase() {
    var _a, _b;
    if (!((_a = self._father) === null || _a === void 0 ? void 0 : _a.alive) ||
        !((_b = self._mother) === null || _b === void 0 ? void 0 : _b.alive) ||
        // Adding 2 to account for mother and father in count
        self._allInheritors.length != self._spouses.length + 2) {
        return false;
    }
    return true;
}
function _getLivingInheritorsWithinList(list) {
    return list.filter((member) => member.alive);
}
function _getGrandSons() {
    const grandsons = [];
    self._sons.forEach((son) => grandsons.push(...son._sons));
    return grandsons;
}
function _getGrandDaughters() {
    const granddaughters = [];
    self._sons.forEach((son) => granddaughters.push(...son._daughters));
    return granddaughters;
}
function _isGrandDaughterEligible() {
    // if more than one daughter or any number of sons are alive, granddaughter is not eligible to inherit, unless grandsons are also eligible
    const blockedByDaughters = _getLivingInheritorsWithinList(self._daughters).length > 1;
    const blockedBySons = _getLivingInheritorsWithinList(self._sons).length > 0;
    const shareWithGrandSons = self._livingGrandSons.length > 0;
    if ((blockedByDaughters && !shareWithGrandSons) || blockedBySons) {
        return false;
    }
    return _getGrandDaughters().length > 0;
}
function _isGrandSonEligible() {
    return (_getLivingInheritorsWithinList(self._sons).length === 0 ||
        self._livingGrandSons.length > 0);
}
function _calculateForGrandDaughters(livingGrandDaughters, amount) {
    let amountDistributed = 0;
    let ratio = 0;
    const livingDaughters = _getLivingInheritorsWithinList(self._daughters);
    if (livingDaughters.length == 0 && livingGrandDaughters.length == 1) {
        ratio = 1 / 2;
    }
    else if (livingDaughters.length == 0 && livingGrandDaughters.length > 1) {
        ratio = 2 / 3;
    }
    else {
        ratio = 1 / 6;
    }
    amountDistributed = _setAmountForAllItemsInList(livingGrandDaughters, ratio / livingGrandDaughters.length, amount);
    taseeb -= amountDistributed;
}
function _calculateForGrandChildren(total) {
    const grandDaughtersAreEligible = _isGrandDaughterEligible();
    const grandSonssAreEligible = _isGrandSonEligible();
    if (!grandDaughtersAreEligible && !grandSonssAreEligible) {
        return;
    }
    const livingGrandDaughters = self._livingGrandDaughters;
    const livingGrandSons = self._livingGrandSons;
    const hasLivingGrandDaughters = livingGrandDaughters.length > 0;
    const hasLivingGrandSons = livingGrandSons.length > 0;
    if (grandDaughtersAreEligible &&
        hasLivingGrandDaughters &&
        hasLivingGrandSons) {
        _calculateTaseebPortionsForBothGendersAtSameLevel(livingGrandSons, livingGrandDaughters);
    }
    else if (grandDaughtersAreEligible && hasLivingGrandDaughters) {
        _calculateForGrandDaughters(livingGrandDaughters, total);
    }
    else if (grandSonssAreEligible && hasLivingGrandSons) {
        _setAmountForAllItemsInList(livingGrandSons, 1 / livingGrandSons.length, taseeb);
        taseeb = 0;
    }
}
function _isGrandFatherEligible() {
    // Can't have grandfather if father is not set
    return self._father != null && !self._father.alive;
}
function _calculateForGrandFather(total) {
    const grandFather = self.getPaternalGrandFather();
    if (!grandFather || !_isGrandFatherEligible()) {
        return;
    }
    _calculateForPaternalAscendant(grandFather, total);
}
function _isPaternalGrandMotherEligible() {
    var _a, _b;
    return ((self._father == null || !self._father.alive) && // Not blocked by father
        (self._mother == null || !self._mother.alive) && // Not blocked by mother
        !!((_a = self._father) === null || _a === void 0 ? void 0 : _a._mother) &&
        ((_b = self._father._mother) === null || _b === void 0 ? void 0 : _b.alive)); // Paternal GrandMother is alive
}
function _isMaternalGrandMotherEligible() {
    return (self._mother != null &&
        !self._mother.alive && // Not blocked by mother
        !!self._mother._mother &&
        self._mother._mother.alive); // Maternal GrandMother is alive
}
function _calculateForGrandMother(total) {
    const livingGrandMothers = [];
    if (_isPaternalGrandMotherEligible()) {
        livingGrandMothers.push(self._father._mother);
    }
    if (_isMaternalGrandMotherEligible()) {
        livingGrandMothers.push(self._mother._mother);
    }
    if (livingGrandMothers.length == 0) {
        return;
    }
    const ratioDue = 1 / 6 / livingGrandMothers.length;
    taseeb -= _setAmountForAllItemsInList(livingGrandMothers, ratioDue, total);
}
function _maybeFixFullBrotherPortions() {
    const fullBrothers = filterFullSiblings(self, self._brothers);
    const maternalBrothers = filterMaternalHalfSiblings(self, self._brothers);
    if (fullBrothers.length == 0 || maternalBrothers.length == 0) {
        return 0;
    }
    const differenceInDistribution = 0;
    if (fullBrothers[0].amountDue < maternalBrothers[0].amountDue) {
        const totalDistributedToMaternalBrothers = maternalBrothers[0].amountDue * maternalBrothers.length;
        const totalDistributedToFullBrothers = fullBrothers[0].amountDue * fullBrothers.length;
        const totalDistributed = totalDistributedToMaternalBrothers + totalDistributedToFullBrothers;
        const newTotalToDistributeToEachGroup = totalDistributed / 2;
        _setAmountForAllItemsInList(maternalBrothers, 1 / maternalBrothers.length, newTotalToDistributeToEachGroup);
        _setAmountForAllItemsInList(fullBrothers, 1 / fullBrothers.length, newTotalToDistributeToEachGroup);
    }
    return differenceInDistribution * maternalBrothers.length;
}
function _calculateForFullSiblings(total) {
    var _a, _b;
    if (((_a = self._father) === null || _a === void 0 ? void 0 : _a.alive) ||
        ((_b = self.getPaternalGrandFather()) === null || _b === void 0 ? void 0 : _b.alive) ||
        self.hasLivingMaleDescendent) {
        return;
    }
    let amountDistributed = 0;
    const fullSisters = filterFullSiblings(self, self._sisters);
    const fullBrothers = filterFullSiblings(self, self._brothers);
    if (fullSisters.length > 0 && fullBrothers.length > 0) {
        amountDistributed = _calculateTaseebPortionsForBothGendersAtSameLevel(fullBrothers, fullSisters);
    }
    else if (fullBrothers.length > 0) {
        const ratioDue = 1 / fullBrothers.length;
        amountDistributed = _setAmountForAllItemsInList(fullBrothers, ratioDue, taseeb);
    }
    else if (fullSisters.length > 0) {
        let ratioDue = 0;
        if (self.hasLivingFemaleDescendent) {
            ratioDue = 1 / fullSisters.length;
            amountDistributed = _setAmountForAllItemsInList(fullSisters, ratioDue, taseeb);
        }
        else {
            const fractionOwedToSisters = fullSisters.length == 1 ? 1 / 2 : 2 / 3;
            ratioDue = fractionOwedToSisters / fullSisters.length;
            amountDistributed += _setAmountForAllItemsInList(fullSisters, ratioDue, total);
        }
    }
    else {
        return;
    }
    // Adjust amount distributed if full brother portions were modified
    amountDistributed += _maybeFixFullBrotherPortions();
    amountDistributed = roundToSixDecimals(amountDistributed);
    taseeb -= amountDistributed;
    taseeb = roundToSixDecimals(taseeb);
}
function _calculateForMaternalHalfSiblings(total) {
    if (self.hasLivingPaternalAncestors()) {
        return 0;
    }
    const maternalHalfSiblings = filterMaternalHalfSiblings(self, [
        ...self._brothers,
        ...self._sisters,
    ]);
    const ratioToDistribute = maternalHalfSiblings.length == 1 ? 1 / 6 : 1 / 3;
    const amountDistributed = _setAmountForAllItemsInList(maternalHalfSiblings, 1 / maternalHalfSiblings.length, total * ratioToDistribute);
    taseeb -= amountDistributed;
}
function _calculateForPaternalHalfSiblings(total) {
    const paternalSisters = filterPaternalHalfSiblings(self, self._sisters);
    const paternalBrothers = filterPaternalHalfSiblings(self, self._brothers);
    let amountDistributed = 0;
    if (paternalBrothers.length > 0 && paternalSisters.length > 0) {
        amountDistributed = _calculateTaseebPortionsForBothGendersAtSameLevel(paternalBrothers, paternalSisters);
    }
    else if (paternalSisters.length > 0 &&
        !self.hasLivingFemaleDescendent &&
        !self.hasLivingPaternalAncestors()) {
        let ratio = 1;
        const fullSisters = filterFullSiblings(self, self._sisters);
        const fullBrothers = filterFullSiblings(self, self._brothers);
        const fullSiblings = [...fullSisters, ...fullBrothers];
        if (paternalSisters.length == 1 && fullSiblings.length === 0) {
            ratio = 1 / 2;
        }
        else if (paternalSisters.length > 1 && fullSiblings.length === 0) {
            ratio = 2 / 3;
        }
        else if (fullSisters.length == 1 && fullBrothers.length == 0) {
            ratio = 1 / 6;
        }
        amountDistributed = _setAmountForAllItemsInList(paternalSisters, 1 / paternalSisters.length, ratio * total);
    }
    else {
        amountDistributed = _setAmountForAllItemsInList(paternalBrothers, 1 / paternalBrothers.length, taseeb);
    }
    taseeb -= amountDistributed;
}
function _calculateForHalfSiblings(total) {
    _calculateForMaternalHalfSiblings(total);
    _calculateForPaternalHalfSiblings(total);
}
function _calculate(total) {
    calculationQueue = [
        () => _calculateForMother(total),
        () => _calculateForFather(total),
        () => _calculateForGrandFather(total),
        () => _calculateForGrandMother(total),
        () => _calculateForHusband(total),
        () => _calculateForWives(total),
        () => _calculateForChildren(total),
        () => _calculateForGrandChildren(total),
        () => _calculateForHalfSiblings(total),
        () => _calculateForFullSiblings(total),
    ];
    // In some cases, we can't calculate a certain person's share until another calculation is confirmed, and the
    // order in which we calculate depends on who is an eligible inheritor. As such, it's possible we try calculating
    // for a single individual or group, only to find out that we need to calculate someone else's share first, so we
    // will push that call back into the queue for it to be calculated later.
    while (calculationQueue.length > 0) {
        // Keep track of calculation currently running, in case we need to add it back
        currentCalcuation = calculationQueue.shift();
        currentCalcuation();
        taseeb = roundToSixDecimals(taseeb);
        // _printLivingInheritors()
    }
    _roundAllLivingInheritorPortions();
    if (_isUmariCase()) {
        _fixPortionsForUmariCases(total);
    }
    _fixPortionsIfTaseebIsNotZero(total);
}
function _roundAllLivingInheritorPortions() {
    _getLivingInheritors().forEach((inheritor) => {
        inheritor.amountDue = roundToSixDecimals(inheritor.amountDue);
    });
}
function _printLivingInheritors() {
    _getLivingInheritors().forEach((inheritor) => {
        console.log(inheritor.name);
        console.log(inheritor.amountDue);
        console.log();
    });
    console.log("=============================================");
}
function _getLivingInheritors() {
    const livingInheritors = [];
    self._allInheritors.forEach((inheritor) => {
        if (inheritor.alive) {
            livingInheritors.push(inheritor);
        }
    });
    return livingInheritors;
}
